import React from 'react';
import Login from '../features/auth/components/Login';
import { useAuth } from '../contexts/AuthContext';

const LoginPage: React.FC = () => {
    const { navigateToRegister } = useAuth();
    return <Login onNavigateToRegister={navigateToRegister} />;
};

export default LoginPage;
